<template>
  <div>
    <h1>Kötelező tervezői és mérnöki szakmai felelősségbiztosítás</h1>
    <div class="mb-2" style="text-align: justify;">
      A tervezők /mérnökök számára elengedhetetlen a megfelelő pénzügyi védelem és biztonság
      megléte. Az új szabályozásoknak köszönhetően minden tervező / mérnök számára kötelező a
      felelősségbiztosítás megkötése. De miért is fontos ez, és hogyan segíthet Önnek? <br /><br />A
      vonatkozó jogszabály kizárólag személyi és dologi károk, illetve sérelemdíjak megtérítését
      írja elő. Azonban a Tervezői / Mérnöki szakmai tevékenység nyújtása során elkövetett hibák
      csak kis esetben okoznak személyi és dologi károkat sokkal valószínűbb a pénzügyi károk
      keletkezése, mint például a szakmai hiba miatti újra építés költségek, javítási költségek.
      Ezért nagyon fontos, hogy a Biztosított megfelelő fedezetet és szolgáltatást nyújtó
      biztosítási terméket válasszon.
    </div>
    <div class="mb-2">
      <b style=" text-align: justify; color: #e4002b;">Fontos!</b>
      A jogszabályok szerinti felelősségbiztosítás <u>nem fedezi</u> a tisztán pénzügyi
      veszteségeket, csak a személyi és dologi károkat, így az
      <b>Alap szakmai felelősségbiztosítási fedezet</b> ennek megfelelően kizárólag a személyi és
      dologi károkat téríti. Amennyiben a <b>Pénzügyi Károk térítése fedezet</b> is választja a
      Biztosított akkor egy komplex szakmai felelősségbiztosítással fog rendelkezni, melynek
      köszönhetően a szakmai hiba következtében keletkezett személyi és dologi károk mellett a
      <u>tisztán pénzügyi veszteségek</u> is térülhetnek, azaz akár az újra építés költségei is.
    </div>
    <div>
      <b
        >Kérjük megfelelően értékelve saját kockázatát a következő oldalon válassza ki az igényelt
        fedezeteket!</b
      >
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import {mapActions} from 'vuex';

export default {
  components: {},
  computed: {
    ...mapFields(['currency', 'insuranceYearlyPrice', 'eves_dij']),
  },
  mounted() {
    this.$store.dispatch('updateMarks');
  },
};
</script>
<style lang="scss">
$red: #e4002b;
.sub {
  color: $red;
  margin-bottom: 10px;
}
</style>
